import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

export const FooterContact = () => (
  <div>
    <h4 className="text-[#3a2a26] font-semibold mb-4">Contact</h4>
    <ul className="space-y-3">
      <li className="flex items-center gap-2 text-[#7a6b62] text-sm">
        <Mail className="w-4 h-4 text-[#b89a6d]" />
        <a href="mailto:everything@8eight8.net" className="hover:text-[#b89a6d] transition-colors">
          everything@8eight8.net
        </a>
      </li>
      <li className="flex items-center gap-2 text-[#7a6b62] text-sm">
        <Phone className="w-4 h-4 text-[#b89a6d]" />
        <a href="tel:+18083012134" className="hover:text-[#b89a6d] transition-colors">
          +1 (808) 301-2134
        </a>
      </li>
      <li className="flex items-start gap-2 text-[#7a6b62] text-sm">
        <MapPin className="w-4 h-4 text-[#b89a6d] mt-0.5" />
        <span>
          PeptidesForMedSpas LLC<br />
          Honolulu, HI 96815, USA
        </span>
      </li>
    </ul>
  </div>
);

export default FooterContact;
